import { useContext } from "react";

import { FindingFiltersContext } from "@providers/FindingFiltersProvider";

export const useFindingFilters = () => {
  const { findingFilters, setFindingFilters } = useContext(
    FindingFiltersContext
  );
  return { findingFilters, setFindingFilters };
};
